<template>
  <div>
    <br>
    <br>
    <el-row>
      <el-col :sm="3" style="padding-top: 10px">
        <el-button size="mini" icon="el-icon-arrow-left" @click="m__back_to_list">{{ $t('base.back') }}</el-button>
      </el-col>
      <el-col :sm="21" style="padding-top: 10px">
        <el-row style="background-color: #fafafa; padding: 20px; font-size: 13px">
          <el-col :sm="16">
            {{ $t('base.status') }}:
            <span v-if="flash_sale && flash_sale.type === 1" class="promotion-status status1">
              {{ $t('base.upcoming') }}
            </span>
            <span v-if="flash_sale && flash_sale.type === 2" class="promotion-status status2">
              {{ $t('base.ongoing') }}
            </span>
            <span v-if="flash_sale && flash_sale.type === 3" class="promotion-status status3">
              {{ $t('base.expired') }}
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {{ $t('flash_sale.live_period') }}: {{ m__get_flash_sale_time() }}
          </el-col>
          <el-col :sm="8" class="text-right">
            <el-button v-if="flash_sale && flash_sale.type === 1" type="text" size="mini" @click="m__back_to_list">
              <strong style="color: orangered"><i class="el-icon-edit" style="color: orangered !important;"></i>
                {{ $t('base.edit') }}</strong>
            </el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <br>

    <el-table class="table-flash-sale" :data="product_ranking" :span-method="objectSpanMethod"
              v-loading="loading.get_data">
      <el-table-column label="#" width="40" fixed="left">
        <template slot-scope="scope">{{ scope.row.index || '' }}</template>
      </el-table-column>
      <el-table-column :label="$t('base.product')" width="80px" fixed="left">
        <template slot-scope="scope">
          <div style="padding: 5px 0;">
            <img :src="SHOPEE_IMAGE(scope.row.product.images[0])" alt="logo"
                 style="width:56px; height: 56px;">
          </div>
        </template>
      </el-table-column>
      <el-table-column width="250px" show-tooltip-when-overflow fixed="left">
        <template slot-scope="scope">
          <a href="javascript:void(0)"
             @click="open_link_fixed(`https://shopee.com/product-i.${seller ? seller.shop_id : ''}.${scope.row.product.id}`, shop)">
            {{ scope.row.product.name }}
          </a>
        </template>
      </el-table-column>
      <el-table-column :label="$t('base.variation')" width="120px">
        <template slot-scope="scope">
          <template v-if="scope.row.models && scope.row.models.length && scope.row.primary">{{
              $t('base.overview')
            }}
          </template>
          <template v-if="scope.row.model && !scope.row.primary">{{ scope.row.model.name }}</template>
        </template>
      </el-table-column>
      <el-table-column :label="$t('flash_sale.campaign_stock')" width="100px">
        <template slot-scope="scope">
          <template v-if="scope.row.models && scope.row.models.length && scope.row.primary">-</template>
          <template v-if="(!scope.row.models || !scope.row.models.length) && scope.row.primary">
            {{ scope.row.campaign_stock }}
          </template>
          <template v-else-if="scope.row.model && !scope.row.primary">{{ scope.row.model.campaign_stock }}</template>
        </template>
      </el-table-column>
      <el-table-column :label="$t('base.discount_price')" width="120px">
        <template slot-scope="scope">
          <template v-if="scope.row.models && scope.row.models.length && scope.row.primary">-</template>
          <template v-if="(!scope.row.models || !scope.row.models.length) && scope.row.primary">
            {{ scope.row.discount_price | currency }} {{ m__currency() }}
          </template>
          <template v-else-if="scope.row.model && !scope.row.primary">
            {{ scope.row.model.discount_price | currency }} {{ m__currency() }}
          </template>
        </template>
      </el-table-column>
      <el-table-column :label="$t('base.sales')" width="110px" prop="sales">
        <template slot-scope="scope">
          <template v-if="scope.row.primary">
            {{ scope.row.sales | currency }} {{ m__currency() }}
          </template>
          <template v-else-if="scope.row.model && !scope.row.primary">
            {{ scope.row.model.sales | currency }} {{ m__currency() }}
          </template>
        </template>
      </el-table-column>
      <el-table-column :label="$t('metric.orders')" width="110px" prop="orders">
        <template slot-scope="scope">
          <template v-if="scope.row.primary">
            {{ scope.row.orders }}
          </template>
          <template v-else-if="scope.row.model && !scope.row.primary">
            {{ scope.row.model.orders }}
          </template>
        </template>
      </el-table-column>
      <el-table-column :label="$t('base.product')" width="110px" prop="units">
        <template slot-scope="scope">
          <template v-if="scope.row.primary">
            {{ scope.row.units }}
          </template>
          <template v-else-if="scope.row.model && !scope.row.primary">
            {{ scope.row.model.units }}
          </template>
        </template>
      </el-table-column>
      <el-table-column :label="$t('flash_sale.no_of_reminders_set')" width="130px" prop="reminder_clicks">
        <template slot-scope="scope">
          <template v-if="scope.row.primary">
            {{ scope.row.reminder_clicks }}
          </template>
          <template v-else>-</template>
        </template>
      </el-table-column>
      <el-table-column :label="$t('metric.product_impressions')" width="110px" prop="product_impression">
        <template slot-scope="scope">
          <template v-if="scope.row.primary">
            {{ scope.row.product_impression }}
          </template>
          <template v-else>-</template>
        </template>
      </el-table-column>
      <el-table-column :label="$t('flash_sale.no_of_product_clicks')" width="110px" prop="product_clicks">
        <template slot-scope="scope">
          <template v-if="scope.row.primary">
            {{ scope.row.product_clicks }}
          </template>
          <template v-else>-</template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

import {fix_ads_mixins} from "../../mixins/fix_ads";

export default {
  name: 'page__flash_sale_data',

  mixins: [fix_ads_mixins],

  props: {
    seller: null,
    flash_sale: null,
    shop: null,
  },

  data() {
    return {
      loading: {
        get_data: false
      },
      tableData: [{
        id: '12987122',
        name: 'Tom',
        amount1: '234',
        amount2: '3.2',
        amount3: 10
      }, {
        id: '12987123',
        name: 'Tom',
        amount1: '165',
        amount2: '4.43',
        amount3: 12
      }, {
        id: '12987124',
        name: 'Tom',
        amount1: '324',
        amount2: '1.9',
        amount3: 9
      }, {
        id: '12987125',
        name: 'Tom',
        amount1: '621',
        amount2: '2.2',
        amount3: 17
      }, {
        id: '12987126',
        name: 'Tom',
        amount1: '539',
        amount2: '4.1',
        amount3: 15
      }],
      product_ranking: []
    }
  },

  async beforeMount() {
    // console.log(this.flash_sale)
    await this.m__get_data()
  },

  methods: {
    m__get_flash_sale_time() {
      if (this.flash_sale) {
        return `${this.dayjs(this.flash_sale.start_time * 1000).format('HH:mm DD-MM-YYYY')} - ${this.dayjs(this.flash_sale.end_time * 1000).format('HH:mm DD-MM-YYYY')}`
      } else {
        return ''
      }
    },

    objectSpanMethod({
                       row,
                       columnIndex
                     }) {
      if ([0, 1, 2].includes(columnIndex)) {
        if (row.primary) {
          if (row.models && row.models.length) {
            return {
              rowspan: row.models.length + 1,
              colspan: 1
            }
          } else {
            return {
              rowspan: 1,
              colspan: 1
            }
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },

    m__back_to_list() {
      this.$emit('m__back_to_list', false)
      this.$emit('m__go_to_edit', this.flash_sale.flash_sale_id)
    },

    async m__get_data() {
      if (!this.flash_sale) {
        return
      }

      this.loading.get_data = true
      const resp = await this.seller.flash_sale_get_product_ranking(this.flash_sale.flash_sale_id)

      this.product_ranking = []
      for (const [index, item] of resp.result.entries()) {
        const row = {
          index: index + 1,
          ...item,
          primary: true,
          model: {},
          product: {
            ...item,
            name: item.item_name,
            images: [item.image],
            status: item.status
          }
        }
        this.product_ranking.push(row)

        if (row.models && row.models.length) {
          for (const model of row.models) {
            const sub_row = {
              ...item,
              model: row.models.find(i => i.model_id === model.model_id),
              primary: false,
              product: {
                ...item,
                name: item.item_name,
                images: [item.image],
                status: item.status
              }
            }
            const model_found = item.models ? item.models.find(i => i.model_id === model.model_id) : null
            if (model_found) sub_row.model.name = model_found.model_name

            this.product_ranking.push(sub_row)
          }
        }
      }

      // for (const [index, item] of resp.result.entries()) {
      //   // const product = product_resp.data.data.list.find(i => i.id === item.item_id)
      //   const product_resp = await this.seller.get_product_detail(item.item_id)
      //   const product = product_resp.data.data.product_info
      //   const row = {
      //     index: index + 1,
      //     ...item,
      //     primary: true,
      //     model: {},
      //     product: {
      //       ...product,
      //       name: product.name,
      //       images: product.images,
      //       status: product.status
      //     }
      //   }
      //   this.product_ranking.push(row)
      //
      //   if (row.models && row.models.length) {
      //     for (const model of row.models) {
      //       const sub_row = {
      //         ...item,
      //         model: row.models.find(i => i.model_id === model.model_id),
      //         primary: false,
      //         product: {
      //           ...product,
      //           name: product.name,
      //           images: product.images,
      //           status: product.status
      //         }
      //       }
      //       const model_found = product.model_list ? product.model_list.find(i => i.id === model.model_id) : null
      //       if (model_found) sub_row.model.name = model_found.name
      //
      //       this.product_ranking.push(sub_row)
      //     }
      //   }
      // }

      this.loading.get_data = false
    }
  }
}
</script>

<style>
.status3 {
  background: #eee;
  color: #999;
}

.status1 {
  background: #fff1f0;
  color: #ee4d2d;
}

.status2 {
  color: #5c7;
  background-color: #eaf9ef
}

.promotion-status {
  display: inline-block;
  font-size: 12px;
  padding: 4px;
  border-radius: 2px;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/flash_sale/data.vue